/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import * as purchaseAction from 'app/shared/store/actions/purchase.action';
import { PurchaseService } from 'app/shared/services';
import { PurchaseState } from '../reducers/purchase.reducer';
import { getPurchaseState } from '../reducers';

@Injectable()
export class PurchaseEffects {
  setPlan$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(purchaseAction.SET_PLAN),
        tap((action: purchaseAction.SetPlan) => {
          const plan = { ...action.payload };
          if (plan) {
            plan.totalPrice = this.purchaseService.roundPrices(action.payload);
          }
          this.purchaseService.setPlan(plan);
        })
      ),
    { dispatch: false }
  );

  resetPlan$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(purchaseAction.RESET_PLAN),
        tap(() => {
          this.purchaseService.resetPlan();
          return null;
        })
      ),
    { dispatch: false }
  );

  setReturnUrl$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(purchaseAction.SET_RETURN_URL),
        tap((action: purchaseAction.SetReturnUrl) => {
          this.purchaseService.setReturnUrl(action.payload);
          return null;
        })
      ),
    { dispatch: false }
  );

  savePurchaseState$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          purchaseAction.ADD_ITEMS,
          purchaseAction.REMOVE_ITEM_AT_INDEX,
          purchaseAction.SET_COUPON,
          purchaseAction.CLEAR_COUPON,
          purchaseAction.SET_INVITEE,
          purchaseAction.SET_PLAN
        ),
        withLatestFrom(this.store.select(getPurchaseState), (action, purchaseState: PurchaseState) => ({
          action,
          purchaseState,
        })),
        tap(({ action, purchaseState }) => {
          this.purchaseService.setPlan(purchaseState);
          return null;
        })
      ),
    { dispatch: false }
  );

  deletePurchaseState$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(purchaseAction.RESET_PLAN),
        tap(() => {
          this.purchaseService.resetPlan();
          return null;
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private purchaseService: PurchaseService,
    private store: Store<PurchaseState>
  ) {}
}
